import { Box, Tabs, type TabsProps } from '@mui/material';
import type { ReactNode } from 'react';
import { usePopoverTabsStyles } from './popoverTabs.styles';

interface PopoverTabsProps {
  value: string;
  onChange: (value: string) => void;
  children: ReactNode;
  variant?: TabsProps['variant'];
  testId?: string;
}

const PopoverTabs = ({ value, onChange, children, variant, testId }: PopoverTabsProps) => {
  const { classes } = usePopoverTabsStyles();

  return (
    <Box className={classes.root} test-id={testId}>
      <Tabs value={value} variant={variant} onChange={(_, newValue) => onChange(newValue)}>
        {children}
      </Tabs>
    </Box>
  );
};

export { default as PopoverTab } from './components/PopoverTab/PopoverTab';
export type { PopoverTabProps } from './components/PopoverTab/PopoverTab';
export type { PopoverTabsProps };
export default PopoverTabs;
